<template>
  <v-list>
    <v-list-item link :to="{name: 'Home', params: {lang:'de'}}" exact :class="$route.name === 'Home' ?  'primary--text': ''">
      <v-list-item-icon>
        <v-icon>mdi-home</v-icon>
      </v-list-item-icon>

      <v-list-item-title>{{ $t('nav.start') }}</v-list-item-title>
    </v-list-item>

    <v-list-item link :to="{name: 'Blog', params: {lang:'de'}}" :class="$route.name === 'Blog' ?  'primary--text': ''">
      <v-list-item-icon>
        <v-icon>mdi-post-outline</v-icon>
      </v-list-item-icon>

      <v-list-item-title>{{ $t('nav.blog') }}</v-list-item-title>
    </v-list-item>

    <v-list-group>
      <template v-slot:activator>
        <v-list-item-icon>
          <v-icon>mdi-picture-in-picture-top-right</v-icon>
        </v-list-item-icon>

        <v-list-item-title>{{ $t('nav.departments') }}</v-list-item-title>
      </template>

      <div v-if="departments.length > 0">
        <v-list-item v-for="item in departments" :key="item._id" link 
          :to="{name: 'Abteilungen', params: {lang:'de', id: item.title}}"
        >
          <v-list-item-title>{{item.title}}</v-list-item-title>
        </v-list-item>
      </div>

      <div v-else>
        <v-list-item>
          <small class="grey--text text-center">{{$t('no_data_loaded')}}</small>
        </v-list-item>
      </div>

    </v-list-group>
    
    <v-list-group>
      <template v-slot:activator>
        <v-list-item-icon>
          <v-icon>mdi-card-bulleted</v-icon>
        </v-list-item-icon>

        <v-list-item-title>{{ $t('nav.workshops') }}</v-list-item-title>
      </template>

    <div v-if="workshops.length > 0">
      <v-list-item v-for="item in workshops" :key="item._id" link :to="{name: 'Workshops', params: {lang:'de', id: item.title.toLowerCase()}}">
          <v-list-item-title>{{item.title}}</v-list-item-title>
        </v-list-item>
    </div>
    <div v-else>
      <v-list-item>
        <small class="grey--text text-center">{{$t('no_data_loaded')}}</small>
      </v-list-item>
    </div>

    </v-list-group>

    <v-list-item link :to="{name: 'Volkslauf', params: {lang:'de'}}" :class="$route.name === 'Volkslauf' ?  'primary--text': ''">
      <v-list-item-icon>
        <v-icon>mdi-run</v-icon>
      </v-list-item-icon>

      <v-list-item-title>{{ $t('nav.run') }}</v-list-item-title>
    </v-list-item>
    
    <v-list-item link :to="{name: 'Formulare', params: {lang:'de'}}" :class="$route.name === 'Formulare' ?  'primary--text': ''">
      <v-list-item-icon>
        <v-icon>mdi-file-document-multiple-outline</v-icon>
      </v-list-item-icon>

      <v-list-item-title>{{ $t('nav.formulars') }}</v-list-item-title>
    </v-list-item>
    

    <!-- <v-list-item link :to="{name: 'Kontakt', params: {lang:'de'}}" :class="$route.name === 'Kontakt' ?  'primary--text': ''">
      <v-list-item-icon>
        <v-icon>mdi-badge-account-horizontal-outline</v-icon>
      </v-list-item-icon>

      <v-list-item-title>{{ $t('nav.contact') }}</v-list-item-title>
    </v-list-item> -->

   <v-list-item  link :to="{name: 'Locations', params: {lang:'de'}}" :class="$route.name === 'Locations' ?  'primary--text': ''">
      <v-list-item-icon>
        <v-icon>mdi-map-marker-radius-outline</v-icon>
      </v-list-item-icon>

      <v-list-item-title>{{ $t('nav.location') }}</v-list-item-title>
    </v-list-item>

    <v-list-item v-if="isLoggedIn" link :to="{name: 'Dashboard', params: {lang:'de'}}" :class="$route.name === 'Dashboard' ?  'primary--text': ''">
      <v-list-item-icon>
        <v-icon>mdi-view-dashboard</v-icon>
      </v-list-item-icon>

      <v-list-item-title>{{ $t('nav.dashboard') }}</v-list-item-title>
    </v-list-item>

  </v-list>
</template>

<script>
// import SidebarItem from "./SidebarItem";
export default {
  // components: { SidebarItem },
  props: ["drawer", "navigations"],
  computed: {
    isLoggedIn() { return this.$store.getters["user/getLoggedIn"] },
    departments() { return this.$store.getters["publicApi/getDepartments"] },
    workshops() { return this.$store.getters["publicApi/getWorkshops"] },
  }
};
</script>

<style lang="scss" scoped>
</style>